import React, { useState } from "react";

import { ContentType, FinancialData, Upload, UploadType } from "@eave/shared/types/api";

import APIClient from "../APIClient";
import BaseTable from "../shared/BaseTable";
import Spinner from "../shared/Spinner";
import Uploader from "../shared/carbon/Uploader";

const FinancialDataBulkTool = () => {
  const [requestInProgress, setRequestInProgress] = useState<boolean>(false);
  const [parsedRecords, setParsedRecords] = useState<FinancialData[]>(undefined);
  const [savedRecords, setSavedRecords] = useState<FinancialData[]>(undefined);
  const [errorRecords, setErrorRecords] = useState<string[]>(undefined);

  return (
    <>
      <Uploader
        uploadType={UploadType.FinancialReportingDataCSV}
        contentTypes={[ContentType.Csv]}
        details="Only .csv files are supported"
        existingUpload={{
          id: null,
          s3_key: null,
        }}
        onUploadHook={(u: Upload) => {
          setRequestInProgress(true);
          return APIClient.post("/uw/financial_data", { s3_path: u.s3_key })
            .then((resp: any) => {
              setParsedRecords(resp.parsed_records);
              setErrorRecords(resp.error_records);
              setSavedRecords(resp.updated_records);
            })
            .catch(err => {
              alert(err?.meta?.error_detail);
            })
            .finally(() => {
              setRequestInProgress(false);
            });
        }}
      />
      <Spinner active={requestInProgress} />
      <>
        {errorRecords && errorRecords.length > 0 && (
          <>
            <h2>Unsuccessful Updates</h2>
            <BaseTable
              headerData={[
                { header: "External Loan ID", key: "external_loan_number" },
                { header: "Error", key: "error" },
              ]}
              rowData={errorRecords
                .map((errorMessage, i) => {
                  return {
                    id: parsedRecords[i].external_loan_number,
                    error: errorMessage,
                    external_loan_number: parsedRecords[i].external_loan_number,
                    parsedRecord: parsedRecords[i],
                  };
                })
                .filter(item => item.error)}
              rawRowData={errorRecords
                .map((errorMessage, i) => {
                  return {
                    id: parsedRecords[i].external_loan_number,
                    error: errorMessage,
                    external_loan_number: parsedRecords[i].external_loan_number,
                    parsedRecord: parsedRecords[i],
                  };
                })
                .filter(item => item.error)}
              disableAllControls // todo: maybe allow edit from here (maybe not delete though)
            />
          </>
        )}
      </>
      <>
        {savedRecords && savedRecords.length > 0 && (
          <>
            <h2>Successful Updates</h2>
            <BaseTable
              headerData={[
                { header: "Loan Id", key: "external_loan_number" },
                { header: "Prepaid Interest", key: "prepaid_interest" },
                {
                  header: "Secondary Market Accrued Interest",
                  key: "secondary_market_accrued_interest",
                },
                {
                  header: "Sales Adjustments and/or Penalties",
                  key: "sales_adjustments_and_or_penalties",
                },
                { header: "Interest Income", key: "interest_income" },
                { header: "Origination Proceeds", key: "origination_proceeds" },
                { header: "Other Revenue", key: "other_revenue" },
                { header: "Curtailments", key: "curtailments" },
                { header: "Additional Fees", key: "additional_fees" },
                { header: "Hedging Gains", key: "hedging_gains" },
              ]}
              rowData={savedRecords
                .filter(item => !!item)
                .map(item => {
                  return {
                    ...item,
                    id: item.external_loan_number,
                  };
                })}
              rawRowData={savedRecords
                .filter(item => item)
                .map(item => {
                  return {
                    ...item,
                    id: item.external_loan_number,
                  };
                })}
              disableAllControls // todo: maybe allow edit from here (maybe not delete though)
            />
          </>
        )}
      </>
    </>
  );
};

export default FinancialDataBulkTool;
